// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"134":"component---src-templates-work-post-tsx","351":"commons","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"134":"85ab315a06a1e7633889","351":"23207bea9e26356fd5f9","678":"335a1da389bfde3bf4dd","731":"bee9a9a28afa76eb924c","843":"1f57fa5e927a86b419cb"}[chunkId] + ".js";
};